export const tooLong = (note: string): boolean => note.length > 500;

export const isNoteValid = (note: string): boolean =>
  note.length >= 5 && note.length <= 500;

export const noteInvalid = (note: string): boolean => !isNoteValid(note);

export const updateNetSuiteIdInvalid = (
  note: string,
  netsuiteId: string,
): boolean => noteInvalid(note) || !netsuiteId.trim();
